export default "__VITE_ASSET__DiHb1x1J__"